module.exports = __webpack_public_path__ + "img/31_28.559cb7f3.png";